/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Updates_AvailableInputs */

const en_no_updates_available = /** @type {(inputs: No_Updates_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Updates Available`)
};

const fr_no_updates_available = /** @type {(inputs: No_Updates_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune mise à jour disponible`)
};

const de_no_updates_available = /** @type {(inputs: No_Updates_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Aktualisierungen verfügbar`)
};

const it_no_updates_available = /** @type {(inputs: No_Updates_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun aggiornamento disponibile`)
};

const ru_no_updates_available = /** @type {(inputs: No_Updates_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновления отсутствуют`)
};

const es_no_updates_available = /** @type {(inputs: No_Updates_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay actualizaciones disponibles`)
};

const zh_cn2_no_updates_available = /** @type {(inputs: No_Updates_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无更新`)
};

const ja_no_updates_available = /** @type {(inputs: No_Updates_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用可能なアップデートはありません`)
};

const hi_no_updates_available = /** @type {(inputs: No_Updates_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई अपडेट उपलब्ध नहीं`)
};

const pt_pt2_no_updates_available = /** @type {(inputs: No_Updates_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma atualização disponível`)
};

/**
* | output |
* | --- |
* | "No Updates Available" |
*
* @param {No_Updates_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_updates_available = /** @type {((inputs?: No_Updates_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Updates_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_no_updates_available(inputs)
	if (locale === "de") return de_no_updates_available(inputs)
	if (locale === "it") return it_no_updates_available(inputs)
	if (locale === "ru") return ru_no_updates_available(inputs)
	if (locale === "es") return es_no_updates_available(inputs)
	if (locale === "zh-CN") return zh_cn2_no_updates_available(inputs)
	if (locale === "ja") return ja_no_updates_available(inputs)
	if (locale === "hi") return hi_no_updates_available(inputs)
	if (locale === "pt-PT") return pt_pt2_no_updates_available(inputs)
	return en_no_updates_available(inputs)
});